(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-single-rows/assets/javascripts/coupon-overview-single-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-single-rows/assets/javascripts/coupon-overview-single-rows.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$tipse = svs.components.tipsen.couponComponents,
  Coupon = _svs$components$tipse.Coupon,
  useCouponContext = _svs$components$tipse.useCouponContext;
const DescriptionSize = svs.components.lbUi.participants.constants.DescriptionSize;
const selectNumberOfStartedBoards = svs.components.tipsen.engine.selectors.couponSelectors.selectNumberOfStartedBoards;
const CouponOverviewSingleRow = svs.components.tipsen.couponOverviewSingleRows.CouponOverviewSingleRow;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM;
const CouponOverviewSingleRows = _ref => {
  let _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  const _useCouponContext = useCouponContext(),
    couponRows = _useCouponContext.couponRows,
    couponId = _useCouponContext.couponId;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const isMediumOrLarge = useMediaQuery(breakpoints.up(BREAKPOINT_AM));
  const numberOfStartedCouponBoards = useSelector(state => selectNumberOfStartedBoards(state, couponId));
  const startedCouponBoards = new Array(numberOfStartedCouponBoards).fill(undefined);
  let nameSize = DescriptionSize.Full;
  if (!isMediumOrLarge && numberOfStartedCouponBoards > 6 || isExtraSmall && numberOfStartedCouponBoards > 2) {
    nameSize = DescriptionSize.Short;
  }
  return React.createElement("div", {
    className: "pg_coupon_overview_single_rows",
    style: style
  }, React.createElement("div", {
    className: "pg_coupon_overview_single_rows__description"
  }, React.createElement("div", {
    className: "pg_coupon_overview_single_rows__description__header"
  }), couponRows.map(row => React.createElement("div", {
    className: "pg_coupon_overview_single_rows__description__row",
    key: row.eventNumber
  }, React.createElement("div", null, row.eventNumber, ".\xA0"), React.createElement("div", {
    className: "pg_coupon_overview_single_rows__description__row__participants"
  }, React.createElement(Coupon.Participant, {
    nameSize: nameSize,
    participant: row.homeParticipant
  }), "\xA0-\xA0", React.createElement(Coupon.Participant, {
    nameSize: nameSize,
    participant: row.awayParticipant
  }))))), React.createElement("div", {
    className: "pg_coupon_overview_single_rows__row"
  }, startedCouponBoards.map((_, boardIndex) => {
    const currentKey = "".concat(couponId, "_").concat(boardIndex);
    return React.createElement(CouponOverviewSingleRow, {
      boardIndex: boardIndex,
      key: currentKey
    });
  })));
};
setGlobal('svs.components.tipsen.couponOverviewSingleRows.CouponOverviewSingleRows', CouponOverviewSingleRows);

 })(window);